import { CustomCategoryCollectionModel, getCustomCategories } from "@iewc/Services/CustomCategoryService";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

addToEndOfChain(chain, async props => {
    if (IS_SERVER_SIDE) {
        console.log("Server side");
        // we get the categories from the api getCustomCategories service
        props.apiResult = await getCustomCategories(props.apiParameter);

        props.dispatch({
            type: "Data/Categories/LoadCustomCategories",
            parameter: props.apiParameter,
            categories: props.apiResult as CustomCategoryCollectionModel,
        } as any);

        return;
    }

    // we try to first get the categories from the session storage variable customCategoryCollectionModel
    // as well we get the date variable customCategoryCollectionModelDate
    // if the date or categories is not there or is older than 1 day, we get the categories from the api getCustomCategories service

    // we need to get the date from the session storage
    const customCategoryCollectionModelDate = sessionStorage.getItem("customCategoryCollectionModelDate");
    const customCategoryCollectionModel = sessionStorage.getItem("customCategoryCollectionModel");

    // we need to get the date from today
    // and format the date to match the date in the session storage
    const dateToday = new Date();

    const dateTodayFormatted =
        dateToday.getFullYear() +
        (dateToday.getMonth() + 1).toString().padStart(2, "0") +
        dateToday.getDate().toString().padStart(2, "0");

    // we check if the date in the session storage is the same as today
    // if it is not, we get the categories from the api
    if (customCategoryCollectionModel && customCategoryCollectionModelDate === dateTodayFormatted) {
        props.apiResult = JSON.parse(customCategoryCollectionModel) as CustomCategoryCollectionModel;
    } else {
        props.apiResult = await getCustomCategories(props.apiParameter);
    }

    props.dispatch({
        type: "Data/Categories/LoadCustomCategories",
        parameter: props.apiParameter,
        categories: props.apiResult as CustomCategoryCollectionModel,
    } as any);
});
